import { Component, inject, signal } from '@angular/core';
import { AppUpdateService } from '@umss/shared/core';
import { UmssAlertComponent } from '../alert/alert.component';

@Component({
  selector: 'umss-update-banner',
  standalone: true,
  imports: [UmssAlertComponent],
  template: `
    @if (appUpdate.bannerState() === 'update-available') {
      <umss-alert
        type="Info"
        variant="soft"
        line1="A new version is available"
        line2="A new version of this app has been deployed. Reload the page to get the latest updates. Any unsaved work will be lost."
        [showActionButton]="true"
        actionButtonLabel="Reload now"
        actionButtonVariant="Primary"
        (onAction)="appUpdate.reloadToUpdate()"
      />
    }
    @if (appUpdate.bannerState() === 'reload-failed' && !dismissed()) {
      <umss-alert
        type="Warning"
        variant="soft"
        line1="Unable to load the latest version"
        line2="Your browser may be caching old files. Try: clearing your browser cache (Ctrl+Shift+Del), opening in a private / incognito window, or disabling browser extensions. If the problem persists, please contact support."
        [showActionButton]="true"
        actionButtonLabel="Try again"
        actionButtonVariant="Outline"
        [showCloseButton]="true"
        (onAction)="appUpdate.reloadToUpdate()"
        (onClose)="dismissed.set(true)"
      />
    }
  `
})
export class UmssUpdateBannerComponent {
  protected appUpdate = inject(AppUpdateService);
  protected dismissed = signal(false);
}
